import { render, staticRenderFns } from "./CategoryResultDetail.vue?vue&type=template&id=d1f2326e&scoped=true"
import script from "./CategoryResultDetail.vue?vue&type=script&lang=js"
export * from "./CategoryResultDetail.vue?vue&type=script&lang=js"
import style0 from "./CategoryResultDetail.vue?vue&type=style&index=0&id=d1f2326e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f2326e",
  null
  
)

export default component.exports